// extracted by mini-css-extract-plugin
export var details = "research-details-module--details--13Bt0";
export var eyebrow = "research-details-module--eyebrow--2lKlF";
export var date = "research-details-module--date--2S8jb";
export var summary = "research-details-module--summary--3vGPW";
export var figure = "research-details-module--figure--2wHYx";
export var paperLink = "research-details-module--paperLink--YR4eT";
export var introduction = "research-details-module--introduction--9HuJz";